var ClickSelect = {

  currentAnswer : 0,
  currentKey : null,
  selector : null,
  activityObj : null,
  correctHash : null,
  keys : [],
  numAttempts : 0,
  answerSpeed : 0.3,
  accessibilityEventID : null,
  isMobile : false,

  init : function ( selector, activityObj, accessibilityEventID, correctHash ) {
    ClickSelect.isMobile              = false;
    ClickSelect.selector              = selector;
    ClickSelect.activityObj           = activityObj;
    ClickSelect.accessibilityEventID  = accessibilityEventID;
    ClickSelect.correctHash           = correctHash;

    ClickSelect.accessibilityListenOn();

    for ( var i = 0; i < activityObj.statements.length; i++ ) {
      $(selector + ' table').append(
        $('<tr></tr>')
          .attr ( 'data-index', i )
          .append([
            $('<td></td>').text(i+1),
            $('<td></td>').text(activityObj.statements[i].text),
            $('<td></td>').append(
              $('<button></button>')
                .attr ( 'class', 'click-select-btn' )
                .html ( 'Click to Select or press <span class="accessibility-key accessibility-key-ref" data-accessibility-key="' + String(i+1).charCodeAt(0) + '"><i>&#xf11c</i> ' + (i+1) + '</span>' )
            ),
          ])
      );
    }

    if ( activityObj.answerOrder && activityObj.answerOrder.length === activityObj.statements.length ) {
      // - NO CHANGE TO THE ANSWER ORDER
    }
    else {
      activityObj.answerOrder = [];
      for ( var i = 0; i < activityObj.statements.length; i++ ) {
        activityObj.answerOrder.push ( i );
      }
    }

    ClickSelect.currentAnswer = 0;
    ClickSelect.displayNextAnswer();

    ClickSelect.activateResetBtn();
  },
  
  mobile : {
    init : function ( selector, activityObj, accessibilityEventID, correctHash ) {
      ClickSelect.isMobile              = true;
      ClickSelect.selector              = selector;
      ClickSelect.activityObj           = activityObj;
      ClickSelect.accessibilityEventID  = accessibilityEventID;
      ClickSelect.correctHash           = correctHash;

      ClickSelect.accessibilityListenOn();

      for ( var i = 0; i < activityObj.statements.length; i++ ) {
        $(selector + ' table').append([
          $('<tr></tr>')
            .attr ( 'data-index', i )
            .append([
              $('<td></td>')
                .attr ( 'rowspan', 2 )
                .append (
                  $('<button></button>')
                    .attr ( 'class', 'click-select-btn' )
                    .append ([
                      $('<span></span>')
                        .addClass ( 'btn-number' )
                        .text ( (i+1) ),
                      $('<i></i>')
                        .addClass ( 'fa fa-hand-point-up faded-pointer' )
                    ])
                ),
              $('<td></td>')
                .text(activityObj.statements[i].text),
            ]),
          $('<tr></tr>')
            .append (
              $('<td></td>')
                .addClass ( "target-host" )
            )
        ]);
      }

      if ( activityObj.answerOrder && activityObj.answerOrder.length === activityObj.statements.length ) {
        // - NO CHANGE TO THE ANSWER ORDER
      }
      else {
        activityObj.answerOrder = [];
        for ( var i = 0; i < activityObj.statements.length; i++ ) {
          activityObj.answerOrder.push ( i );
        }
      }

      ClickSelect.currentAnswer = 0;
      ClickSelect.displayNextAnswer();

      ClickSelect.activateResetBtn();
    },
  },

  displayNextAnswer : function() {
    if ( ClickSelect.currentAnswer < ClickSelect.activityObj.statements.length ) {
      $('.current-answer').removeClass ( 'current-answer' );

      var answerIndex = ClickSelect.activityObj.answerOrder[ClickSelect.currentAnswer];
      ClickSelect.currentKey = md5(String(answerIndex)).substr(0,4);
      
      ClickSelect.addNextAnswer ( answerIndex, true );
      
      var answerTween = {
        top: '340px',
        delay: 0.7,
        onComplete: ClickSelect.displayNextAnswerComplete,
      };

      if ( ClickSelect.isMobile ) {
        answerTween.top = '75%';
      }
      TweenMax.to ( '.current-answer', ClickSelect.answerSpeed, answerTween );

      ClickSelect.currentAnswer++;
    }
    else {
      ClickSelect.showCheckAnswersBtn();
    }
  },

  addNextAnswer : function ( answerIndex, addCurrentClass ) {
    var newAnswer = $('<div></div>')
      .addClass ( 'cs-answer' )
      .attr ( 'data-key', ClickSelect.currentKey )
      .text ( ClickSelect.activityObj.statements[answerIndex].answer );
    
    if ( addCurrentClass ) {
      $(newAnswer).addClass ( 'current-answer' );
    }

    $(ClickSelect.selector).append ( newAnswer );
  },

  displayNextAnswerComplete : function() {
    ClickSelect.activateSelectBtns();
    ClickSelect.accessibilityListenOn();
  },

  activateSelectBtns : function() {
    $('.click-select-btn')
      .off ( 'click' )
      .on  ( 'click', function ( evt ) {
        ClickSelect.deactivateSelectBtns();

        var btn = $(evt.target).closest('button');
        ClickSelect.keys[$(btn).closest('tr').attr ( 'data-index' )] = ClickSelect.currentKey;

        if ( ClickSelect.isMobile ) {
          var targetTD = $(btn).parent().parent().next().find('td')[0];

          TweenMax.to('.current-answer', ClickSelect.answerSpeed, {
            autoAlpha: 0,
            onComplete: function() {
              $(targetTD).html ( $('.current-answer').html() );
              ClickSelect.displayNextAnswer();
            },
          });
        }
        else {
          TweenMax.to('.current-answer', ClickSelect.answerSpeed, {
            top: $(btn).offset().top - $(btn).closest('table').offset().top + 5,
            left: $(btn).offset().left - $(btn).closest('table').offset().left + 5,
            onComplete: ClickSelect.displayNextAnswer,
          });
        }
      });
  },

  deactivateSelectBtns : function() {
    $('.click-select-btn')
      .off ( 'click' );
  },

  accessibilityListenOn : function() {
    $('body')
      .off ( 'keydown.' + ClickSelect.accessibilityEventID )
      .on  ( 'keydown.' + ClickSelect.accessibilityEventID, function ( evt ) {
        $('.accessibility-key').each ( function ( index, elem ) {
          if ( evt.keyCode == $(elem).attr('data-accessibility-key') ) {
            ClickSelect.accessibilityListenOff();

            var btn = $(elem).closest('button');
            ClickSelect.keys[$(btn).closest('tr').attr ( 'data-index' )] = ClickSelect.currentKey;

            TweenMax.to ( '.current-answer', 0.3, {
              top: $(btn).offset().top - $(btn).closest('table').offset().top + 5,
              left: $(btn).offset().left - $(btn).closest('table').offset().left + 5,
              onComplete: ClickSelect.displayNextAnswer,
            });
          }
        });
        
        // - RESET ASSIGNED TO R
        if ( evt.keyCode == 82 ) {
          ClickSelect.restart();
        }
      });
  },

  accessibilityListenOff : function() {
    $('body').off ( 'keydown.' + ClickSelect.accessibilityEventID );
  },

  showCheckAnswersBtn : function() {
    TweenMax.to ( '#cs-check-answers-btn', 1, {
      autoAlpha: 1,
      onComplete: function() {
        // - CHECK ANSWERS ASSIGNED TO C
        $('body')
          .off ( 'keydown.checkAnswers' )
          .on  ( 'keydown.checkAnswers', function ( evt ) {
            if ( evt.keyCode == 67 && ClickSelect.allPlaced() ) {
              ClickSelect.checkAnswers();
            }
          });
        
        $('#cs-check-answers-btn')
          .off ( 'click' )
          .on  ( 'click', function ( evt ) {
            ClickSelect.checkAnswers();
          });
      },
    });
  },

  hideCheckAnswersBtn : function() {
    // - CHECK ANSWERS ASSIGNED TO C
    $('body')
     .off ( 'keydown.checkAnswers' );

    $('#cs-check-answers-btn')
      .off ( 'click' );

    TweenMax.to ( '#cs-check-answers-btn', 1, {
      autoAlpha: 0,
    });
  },

  allPlaced : function() {
    console.log(ClickSelect.keys, ClickSelect.activityObj.statements);
    return ClickSelect.keys.length === ClickSelect.activityObj.statements.length;
  },

  checkAnswers : function() {
    ClickSelect.hideCheckAnswersBtn();

    var checkString = ClickSelect.keys.join("");

    if ( md5(checkString) === ClickSelect.correctHash ) {
      Courses.popup.showDynamicPopup ( 'That\'s correct, well done.<br><br>You can now close this popup and continue using the navigation provided.', {
        width: '500px',
        height: '50px',
      });

      Courses.content.setCurrSlideComplete();
    }
    else {
      ClickSelect.numAttempts++;

      if ( ClickSelect.numAttempts > 2 ) {
        Courses.popup.showDynamicPopup ( 'That\'s not quite right.<br><br>Please close this popup and press the reset button to try again or click \'Reveal Answers\' to continue.', {
          width: '500px',
          height: '90px',
          onClose: function() {
            TweenMax.to ( '#cs-reveal-answers-btn', 1, {
              autoAlpha: 1,
              onComplete: ClickSelect.activateRevealAnswersBtn,
            });
            
            ClickSelect.restart();
          },
        });
      }
      else {
        Courses.popup.showDynamicPopup ( 'That\'s not quite right.<br><br>Please close this popup and press the reset button to try again.', {
          width: '500px',
          height: '90px',
          onClose: ClickSelect.restart,
        });
      }
    }
  },

  activateResetBtn : function() {
    $('#cs-reset-btn')
      .off ( 'click' )
      .on  ( 'click', function ( evt ) {
        ClickSelect.restart();
      });
  },

  reset : function() {
    $('.cs-answer').remove();

    ClickSelect.currentAnswer = 0;
    ClickSelect.keys = [];
    ClickSelect.currentKey = null;

    $('.target-host').html('');

    ClickSelect.hideCheckAnswersBtn();
  },

  restart : function() {
    ClickSelect.reset();
    TweenMax.delayedCall ( 1.2, ClickSelect.displayNextAnswer );
  },

  activateRevealAnswersBtn : function() {
    // - REVEAL ANSWERS ASSIGNED TO A
    $('body')
      .off ( 'keydown.revealAnswers' )
      .on  ( 'keydown.revealAnswers', function ( evt ) {
        if ( evt.keyCode == 65 && ClickSelect.numAttempts > 2 ) {
          ClickSelect.revealAnswers();
        }
      });

    $('#cs-reveal-answers-btn')
      .off ( 'click' )
      .on  ( 'click', function ( evt ) {
        ClickSelect.revealAnswers();
      });
  },

  deactivateRevealAnswersBtn : function() {
    // - REVEAL ANSWERS ASSIGNED TO A
    $('body')
      .off ( 'keyDown.revealAnswers' );

    $('#cs-reveal-answers-btn')
      .off ( 'click' );
  },

  revealAnswers : function() {
    ClickSelect.deactivateRevealAnswersBtn();

    ClickSelect.reset();

    for ( var i = 0; i < ClickSelect.activityObj.answerOrder.length; i++ ) {
      if ( ClickSelect.isMobile ) {
        var answerIndex = ClickSelect.activityObj.answerOrder[i];

        $('#activity-area tr[data-index="' + answerIndex + '"]').next().find('td').html ( ClickSelect.activityObj.statements[answerIndex].answer );
      }
      else {
        TweenMax.delayedCall ( i*3, function(i) {
          var answerIndex = ClickSelect.activityObj.answerOrder[i];
          ClickSelect.addNextAnswer ( answerIndex, true );
          ClickSelect.displayNextAnswer();
          TweenMax.delayedCall ( 1, function(answerIndex, i) {
            var btn = $('tr[data-index="' + answerIndex + '"] button');
            ClickSelect.keys[$(btn).closest('tr').attr ( 'data-index' )] = ClickSelect.currentKey;

            TweenMax.to('.current-answer', ClickSelect.answerSpeed, {
              top: $(btn).offset().top - $(btn).closest('table').offset().top + 5,
              left: $(btn).offset().left - $(btn).closest('table').offset().left + 5,
              onComplete: function() {
                $('.current-answer').removeClass ( 'current-answer' );
              },
            });
          }, [answerIndex, i] );
        }, [i] );
      }
    }

    TweenMax.delayedCall ( i*2+1, function() {
      Courses.content.setCurrSlideComplete();
    });

    TweenMax.delayedCall ( i*2+4, function() {
      Courses.popup.showDynamicPopup ( 'The answers as displayed are now in the correct order, feel free to study them or click the next button to move on.', {
        width: '500px',
        height: '50px',
      });
    });
  },

};